import { render, staticRenderFns } from "./home_advantages.vue?vue&type=template&id=ba24fec6&scoped=true"
import script from "./home_advantages.vue?vue&type=script&lang=js"
export * from "./home_advantages.vue?vue&type=script&lang=js"
import style0 from "./home_advantages.vue?vue&type=style&index=0&id=ba24fec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba24fec6",
  null
  
)

export default component.exports